import { render, staticRenderFns } from "./FHoverCopy.vue?vue&type=template&id=bb905fea&"
import script from "./FHoverCopy.vue?vue&type=script&lang=ts&"
export * from "./FHoverCopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports